<div *ngIf="fileList && fileList.length > 0">
  <button 
    (click)="showDocumentsHistory($event)"
    [disableRipple]="true"
    class="form-toggle view-documents-btn"
    mat-button>
    <span i18n>View Uploaded Documents</span> 
    <mat-icon color="primary">play_arrow</mat-icon>
  </button>
</div>